<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />

      <modal :show.sync="modals.supportdoc" class="modal-eprf" centered>
        <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
          header="DOCUMENTS" header-bg-variant="primary" header-text-variant="white">
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">DOCUMENTS</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.supportdoc = false"></i>
                </base-button>
              </div>
            </div>
          </template>

          <div :style="{
            height: otheropen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }">
            <div class="col-lg-12">
              <el-table :data="allfilename" :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }">
                <el-table-column width="100" align="center">
                  <template slot="header" slot-scope="scope">
                    <div @click="openother()" style="cursor: pointer">
                      <span>{{ scope.column.label }}</span>
                    </div>
                  </template>
                  <div v-if="otheropen == true" slot-scope="scope">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.$index + 1 }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="Job Supporting Documents" :min-width="350" prop="filename" align="center">
                  <template slot="header" slot-scope="scope">
                    <div @click="openother()" style="cursor: pointer">
                      <span>{{ scope.column.label }}</span>
                    </div>
                  </template>
                  <div v-if="otheropen == true" slot-scope="scope" style="height: 20px" align="left">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.row.filename }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="▼" width="100" align="center">
                  <div v-if="otheropen == true" slot-scope="scope">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i style="color: #A5A5A5; font-size: 18px; font-weight: 900"
                        class="tim-icons icon-cloud-download-93"></i>
                    </a>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div :style="{
            height: quoopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }">
            <div class="col-lg-12">
              <el-table :data="allquodocname" :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }">
                <el-table-column width="100" align="center">
                  <template slot="header" slot-scope="scope">
                    <div @click="openquo()" style="cursor: pointer">
                      <span>{{ scope.column.label }}</span>
                    </div>
                  </template>
                  <div v-if="quoopen == true" slot-scope="scope">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.$index + 1 }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="Quotation Supporting Documents" :min-width="350" prop="filename" align="center">
                  <template slot="header" slot-scope="scope">
                    <div @click="openquo()" style="cursor: pointer">
                      <span>{{ scope.column.label }}</span>
                    </div>
                  </template>
                  <div v-if="quoopen == true" slot-scope="scope" style="height: 20px" align="left">
                    <p style="font-size: 14px; color: #707070">
                      {{ scope.row.filename }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="▼" width="100" align="center">
                  <div v-if="quoopen == true" slot-scope="scope">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i style="color: #A5A5A5; font-size: 18px; font-weight: 900"
                        class="tim-icons icon-cloud-download-93"></i>
                    </a>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </b-card>
      </modal>
      <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>{{ title }}</h1>
            <p>
              {{ message }}
            </p>
          </div>
        </div>
      </modal>

      <modal :show.sync="modals.warningsubmit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">Please fill in all the forms.</div>
        </div>
      </modal>
      <!-- add -->
      <div v-if="$route.params.action == 'edit'">
        <div class="row">
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ORDER READY DATE
              </p>
              <div style="">
                <p class="new-title">
                  Date <span v-if="displayflag" style="color: #EC1B23">*</span>
                </p>
                <p class="subtitle" v-if="!displayflag">
                  {{ selectedDate }}
                </p>
                <el-date-picker v-if="displayflag" v-model="selectedDate" style="width: 90%" @change="updateDate()">
                </el-date-picker>
              </div>
              <br />
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                VENDOR DETAILS
              </p>
              <div style="height: 490px; overflow: auto; overflow-x: hidden">
                <p class="new-title">
                  Company Name
                  <span v-if="displayflag" style="color: #EC1B23">*</span>
                </p>
                <p class="subtitle" v-if="!displayflag">
                  {{ companyname }}
                </p>

                <el-select v-if="displayflag" class="select-info tab select-width" popper-class="custom-dropdown"
                  placeholder="Select" v-model="selects.vendor" style="width: 100%; border-bottom: 1px solid lightgray">
                  <el-option-group v-for="group in selects.vendors" :key="group.label" :label="group.label">
                    <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-option-group>
                </el-select>

                <p class="new-title">Company Phone No.</p>
                <p class="subtitle">
                  {{ companyphoneno }}
                </p>
              </div>
            </card>
          </div>
          <div class="col-lg-8 d-flex">
            <card class="card-eprf">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                WASTE DETAILS
              </p>
              <div style="height: 490px; overflow: auto; overflow-x: hidden">
                <div class="row">
                  <div class="col-lg">
                    <el-table :data="tableData" :header-cell-style="{
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#707070',
                    }" :cell-style="{ fontColor: '#707070' }" :row-style="tableRowClassName" style="color: #707070">
                      <el-table-column width="50">
                        <div slot-scope="scope">
                          <p v-if="scope.row.flag == 'data'" style="font-size: 14px; color: #707070">
                            {{ scope.$index + 1 }} .
                          </p>
                          <!-- <base-button
                            class="btn-icon btn-round btn-sm"
                            style="color: #ffffff; font-size: 13px"
                            >{{ scope.$index + 1 }}</base-button
                          > -->
                        </div>
                      </el-table-column>
                      <el-table-column label="Waste Type" prop="wastetypename">
                      </el-table-column>
                      <el-table-column label="Waste Component" prop="wastecomponent">
                        <div slot-scope="{ row }">
                          <p v-for="(item, index) in row.wastecomponent" :key="index"
                            style="font-size: 14px; color: #707070">
                            {{ index + 1 }}. {{ item }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column label="Quantity">
                        <div slot-scope="{ row }">
                          <div class="row">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #707070">
                                {{ row.qty }} {{ row.qtyunit }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #707070">
                                {{ row.packaging }} {{ row.packagingunit }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </el-table-column>

                      <el-table-column label="Price">
                        <div slot-scope="{ row }">
                          <div class="row" v-if="row.flag == 'data'">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #707070">
                                RM {{ row.price }} / {{ row.qtyunit }}
                              </p>
                            </div>
                          </div>
                          <div class="row" v-if="row.flag == 'total'">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #707070; font-weight: bold">
                                Total
                              </p>
                            </div>
                          </div>
                          <div class="row" v-if="row.flag == 'grandtotal'">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #707070; font-weight: bold">
                                Grand Total
                              </p>
                            </div>
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column label="Amount" align="center">
                        <!-- <div slot-scope="{ row }"> -->
                        <el-table-column label="Sell" align="center">
                          <div slot-scope="{ row }">
                            <p style="font-size: 14px; color: #707070" v-if="row.for_sell && row.flag == 'data'">
                              RM {{ row.amount }}
                            </p>
                            <p style="font-size: 14px; color: #707070; font-weight: bold" v-if="row.flag == 'total'">
                              RM {{ row.sellamount }}
                            </p>
                          </div>
                        </el-table-column>
                        <el-table-column label="Buy" align="center">
                          <div slot-scope="{ row }">
                            <p style="font-size: 14px; color: #707070" v-if="!row.for_sell && row.flag == 'data'">
                              RM {{ row.amount }}
                            </p>
                            <p style="font-size: 14px; color: #707070; font-weight: bold" v-if="row.flag == 'total'">
                              RM {{ row.buyamount }}
                            </p>
                            <p style="font-size: 14px; color: #707070; font-weight: bold"
                              v-if="row.flag == 'grandtotal'">
                              RM {{ row.grandtotal }}
                            </p>
                          </div>
                        </el-table-column>

                        <!-- <div class="row">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #707070">
                                RM {{ row.amount }}
                              </p>
                            </div>
                          </div> -->
                        <!-- </div> -->
                      </el-table-column>
                      <!-- <el-table-column label="Remark" prop="remark">
                      </el-table-column> -->
                    </el-table>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-2"></div>
        </div>

        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button type="danger" v-on:click="prevTab()">Back</base-button>&nbsp;
            <base-button type="primary" v-on:click="assignvendor()" v-if="displayflag">Assign Vendor</base-button>&nbsp;
            <base-button type="primary" v-on:click="nextTab()" v-if="!displayflag">Next</base-button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg text-right">
            <p style="color: #EC1B23">{{ errmsg }}</p>
          </div>
        </div>
        <div v-if="submit == false" class="row">
          <div class="col-lg"></div>
          <div v-if="warning == true" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              {{ otherswarning }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  OptionGroup,
} from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  // props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      selltotal: 0,
      buytotal: 0,
      selectedDate: "",
      companyname: "",
      companyphoneno: "-",
      title: "",
      message: "",
      tableData: [],
      errmsg: "",
      otheropen: false,
      quoopen: false,
      imgmsg: "",
      modal: modal,
      docs: "",
      picsubmitted: "",
      imageurl: [],
      phoneno: "",
      wastecomp: "",
      wastetype: "",
      // buttonadd: false,
      //data from submitted data
      locationsubmitted: "",
      wastetypesubmit: "",
      swcodesubmit: "",
      packagingsubmit: "",
      wasteoriginsubmit: "",
      wastecomponentsubmit: [],
      estqtysubmit: "",
      measurementsubmit: "",
      remarkssubmit: "",

      otherswarning: "Please click add new waste type before you submit",
      warning: false,
      showOverlay: false,
      uploadload: false,
      selectedFileName: "",
      allfilename: [],
      allquodocname: [],

      wcodone: false,
      jobreferenceno: "",
      picphoneno: "",
      picemail: "",

      pdftable: [{ no: 0, waste: "", est: "", pack: "" }],

      picdetail: [
        {
          phoneno: "",
          email: "",
          faxno: "",
        },
      ],

      email: "",
      faxno: "",

      wastearray: [],

      referenceno: "",
      wastejobid: 0,

      load: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      specify: "",
      specifywastetype: "",

      deliveryterm: "",
      paymentterm: "",

      jobno: "",
      estimatequatity: "",

      wasteorigin: "",
      remarks: "",

      selects: {
        vendor: "",
        vendors: [],
        // location: "",
        // locations: [
        //   // { value: 1, label: "Workshop Asia Port, CT1" },
        //   // { value: 2, label: "Workshop Asia Port, CT1" },
        //   // { value: 3, label: "Others (Please specify)" },
        // ],

        // pic: "",
        // pics: [
        //   // { value: 1, label: "Amirah binti Azman" },
        //   // { value: 2, label: "Yahya Abd Rahman" },
        //   // { value: 3, label: "Haziq Haikal bin Ayub" },
        // ],

        // wastetype: "",
        // wastetypes: [
        //   // { value: 1, label: "Scheduled Waste" },
        //   // { value: 2, label: "Garbage" },
        //   // { value: 3, label: "Sewage" },
        //   // { value: 4, label: "Scrap" },
        //   // { value: 5, label: "Others" },
        // ],

        // swcode: "",
        // swcodes: [
        //   // { value: 1, label: "SW101" },
        //   // { value: 2, label: "SW102" },
        //   // { value: 3, label: "SW103" },
        //   // { value: 4, label: "SW104" },
        //   // { value: 5, label: "SW105" },
        // ],

        // packaging: "",
        // packagings: [
        //   { value: 1, label: "Drum" },
        //   { value: 2, label: "Carboy" },
        //   { value: 3, label: "Box" },
        //   { value: 4, label: "Jumbo Bag" },
        //   { value: 5, label: "IBC" },
        //   { value: 6, label: "Unit" },
        // ],

        // measurement: 1,
        // measurements: [
        //   { value: "MT", label: "MT" },
        //   { value: "M³", label: "M³" },
        // ],

        // collection: 1,
        // collections: [],
      },

      wastedetail: [
        {
          prop: "wastetype",
          label: "Waste Type",
        },
        {
          prop: "wastecomponent",
          label: "Waste Component",
        },
        {
          prop: "estqty",
          label: "EST. QTY.",
        },
        {
          prop: "remarks",
          label: "Remarks",
        },
      ],

      tableDatas: [
        {
          index: 0,
          id: "1",
          buttonadd: true,
          wastetype: "",
          nickname: "",
          swcode: "",
          swcodes: [],
          packaging: "",
          wasteorigin: "",
          wasteComponents: [
            {
              component_name: "",
            },
          ],
          estqty: "",
          estqtyy: "",
          packagingname: "",
          measurement: "",
          remarks: "",
          images: [],
          previewImage: [],
          // "https://www.tutorialspoint.com/assets/questions/media/426142-1668760872.png",
        },
      ],

      packagingname: "",

      modals: {
        submit: false,
        warningsubmit: false,
        supportdoc: false,
        successModal: false,
      },
      submit: false,

      newwastetypeid: null,

      collectiondate: "",

      submitted: false,
      documentID: [],

      //pdf
      // companyname: "",
      deliveryno: "NPX1234",
      date: "",
      currentpage: "",
      totalpage: "",
      companyaddress: "",
      // companyphoneno: "",
      companyemail: "xxx@gmail.com",
      attention: "",
      subject: "Quotation for Scheduled Waste for PRF",

      deliverypdf: "7",
      paymentpdf: "30",
      validitypdf: "30",
      remarkspdf:
        "Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF",

      pic1pdf: "",
      pic1nopdf: "",
      pic2pdf: "",
      pic2nopdf: "",

      packagingchose: "",
      packagingLabel: "",

      gambarwco: [],

      wastecomponent: [],
      positionid: "",
      status: "",
      displayflag: false,
    };
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    if (this.$route.params.action == "edit") {
      this.getVendor();

      setTimeout(() => {
        this.getData();
      }, 1000);
    }
  },
  mounted() { },
  computed: {},
  watch: {
    "selects.vendor"() {
      console.log(this.selects.vendor);
      console.log(this.tableData);
      for (var i = 0; i < this.selects.vendors.length; i++) {
        console.log(this.selects.vendors[i]);
        for (var j = 0; j < this.selects.vendors[i].options.length; j++) {
          if (this.selects.vendor == this.selects.vendors[i].options[j].value) {
            console.log("sameh");
            console.log(this.selects.vendors[i].options[j]);
            this.tableData = this.selects.vendors[i].wastedetail;
          }
        }
      }

      console.log(this.tableData);
    },
    positionid() {
      console.log(this.positionid);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      console.log(this.status);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
  },
  methods: {
    assignvendor() {
      console.log("assign vendor");

      let obj = {
        company_id: this.selects.vendor,
      };

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
          this.$route.params.jobnum +
          "/vendor",
          obj
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.title = "Successfull!";
            this.message = "Vendor successfully assigned.";
            this.modals.submit = true;
            setTimeout(() => {
              this.modals.submit = false;
            }, 2000);

            this.redirect();
          }
        });
    },
    updateDate() {
      console.log(this.selectedDate);
      let obj = {
        date: moment(this.selectedDate).format("YYYY-MM-DD"), //YYYY-MM-DD
      };

      this.$http
        .put(
          ":10001/api/v1/outgoing/waste/" +
          this.$route.params.jobnum +
          "/update_ready_date",
          obj
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.title = "Successfull!";
            this.message = " Date successfully updated!";
            this.modals.submit = true;

            setTimeout(() => {
              this.modals.submit = false;
            }, 1000);

            this.getData();
          }
        });
    },
    getVendor() {
      this.selects.vendors = [];

      this.$http
        .get(
          ":10001/api/v1/outgoing/waste/" +
          this.$route.params.jobnum +
          "/vendor"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let wastedetail = [];
              for (var j = 0; j < response[i].waste_detail.length; j++) {
                if (response[i].waste_detail[j].for_sell == true) {
                  this.selltotal += response[i].waste_detail[j].amount

                }
                if (response[i].waste_detail[j].for_sell == false) {
                  this.buytotal += response[i].waste_detail[j].amount
                }

                let waste = {
                  wastetypeid:
                    response[i].waste_detail[j].waste_type.waste_type_id,
                  wastetypename: response[i].waste_detail[j].waste_type.name,
                  wastecomponent: response[i].waste_detail[j].waste_component,
                  qty: response[i].waste_detail[j].quantity,
                  qtyunit: response[i].waste_detail[j].quantity_unit,
                  packaging: response[i].waste_detail[j].packaging_quantity,
                  packagingunit: response[i].waste_detail[j].packaging.name,
                  remark: response[i].waste_detail[j].remark,
                  price: response[i].waste_detail[j].price,
                  amount: response[i].waste_detail[j].amount,
                  for_sell: response[i].waste_detail[j].for_sell,
                  flag: "data"
                };

                wastedetail.push(waste);


              }

              let total = {
                sellamount: this.selltotal,
                buyamount: this.buytotal,
                // for_sell: response[i].waste_detail[j].for_sell,
                flag: "total"
              };

              wastedetail.push(total);

              let grandtotal = {
                grandtotal: this.selltotal - this.buytotal,
                flag: "grandtotal"
              };

              wastedetail.push(grandtotal);


              let obj = {};
              if (i == 0) {
                obj = {
                  label: "Recommended",
                  options: [
                    {
                      label: response[i].company_name,
                      value: response[i].company_id,
                    },
                  ],
                  wastedetail: wastedetail,
                };
              } else {
                obj = {
                  label: "Others",
                  options: [
                    {
                      label: response[i].company_name,
                      value: response[i].company_id,
                    },
                  ],
                  wastedetail: wastedetail,
                };
              }

              this.selects.vendors.push(obj);
            }
          }
        });
    },
    redirect() {
      this.$router.push("/Outgoing");
    },

    getData() {
      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.status = response.status.status;
            this.selectedDate = moment(response.proposed_date).format(
              "YYYY-MM-DD"
            );

            if (response.company_vendor != null) {
              this.companyname = response.company_vendor.company_name;
              this.companyphoneno = response.company_vendor.phone_number;
              this.selects.vendor = response.company_vendor.company_id;
            }
          }
        });
    },

    prevTab() {
      // this.$router.push("/Outgoing");
      let parameter = {
        step: "3",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "3",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
      // this.validateStep('step2')
    },

    handleInput(value) {
      if (value.trim() !== "") {
        this.warning = true;
      }
    },

    handleSpecify(name, row) {
      let obj = {
        name,
      };

      this.$http.post(":10001/api/v1/self/waste-type", obj).then((res) => {
        if (!res.error) {
          let response = res.message;

          this.newwastetypeid = response.waste_type_id;
          this.warning = false;
          //buang button
          row.buttonadd = false;
        } else {
        }
      });
      this.warning = false;
    },

    submitData() {
      this.modals.submit = true;
      setTimeout(() => {
        this.modals.submit = false;
      }, 1500);

      this.submit = true;
      this.getPDF();
    },

    getNext() { },

    getDeleteRow(row) {
      console.log(row);
      this.tableDatas.splice(row, 1);
      // wastetype
    },

    addRow() {
      let obj = {
        index: this.tableDatas.length,
        id: this.tableDatas.length + 1,
        buttonadd: true,
        wastetype: "",
        swcode: "",
        swcodes: [],
        packaging: "",
        wasteorigin: "",
        wasteComponents: [
          {
            component_name: "",
          },
        ],
        estqty: "",
        estqtyy: "",
        packagingname: "",
        measurement: "",
        remarks: "",
        images: [],
      };

      this.tableDatas.push(obj);
    },

    // submit() {
    //   this.showOverlay = true;
    //   setTimeout(() => {
    //     this.showOverlay = false;
    //     this.wcodone = true;
    //   }, 5000);
    // },
    // onFileChange(event) {
    //   this.uploadload = true;
    //   const t = event.target;
    //   if (t.files.length > 0) {
    //     for (let i = 0; i < t.files.length; i++) {
    //       this.selectedFileName = t.files[i].name;
    //       // this.allfilename.push(this.selectedFileName);
    //     }
    //   } else {
    //     this.selectedFileName = "";
    //   }

    //   this.document = t.files.length;

    //   var input;
    //   if (t.files.length > 0) {
    //     for (let i = 0; i < t.files.length; i++) {
    //       input = this.$refs.file.files[i];
    //       const formData = new FormData();
    //       formData.append("document", input);
    //       this.docs = formData;

    //       this.uploadload = true;
    //       this.buttondisabled = true;

    //       this.$http
    //         .post(
    //           ":10001/api/v1/incoming/" +
    //           this.jobno +
    //           "/upload/upload-waste-job",
    //           this.docs,
    //           {
    //             headers: {
    //               Authorization: `Bearer ${getStorage("token")}`,
    //               "Content-Type": "multipart/form-data",
    //             },
    //           }
    //         )
    //         .then((res) => {
    //           if (!res.error) {
    //             let response = res.message;
    //             this.documentID.push(response.document_id);
    //             this.modals.successModal = true;
    //             this.uploadload = false;

    //             // hmm
    //             this.getSubmittedData();
    //           } else {
    //             console.log("data tak masuk");
    //           }
    //         });

    //       this.buttondisabled = false;
    //     }
    //   }
    // },

    onFileChange(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.selectedFileName = filesArray.map((file) => file.name).join(", ");
        this.document = filesArray.length;

        const uploadPromises = [];

        this.uploadload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          this.buttondisabled = true;

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/upload-waste-job",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.getSubmittedData();
              } else {
                console.log("data tak masuk");
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.uploadload = false;
            this.buttondisabled = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.selectedFileName = "";
        this.document = 0;
      }
    },
    removeFile(indexToRemove) {
      // let documentremove = this.documentID[indexToRemove];

      // if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
      //   this.allfilename.splice(indexToRemove, 1);
      //   this.documentID.splice(indexToRemove, 1);
      // }

      this.$http
        .delete(
          ":10001/api/v1/incoming/" +
          this.jobno +
          "/upload/upload-waste-job/" +
          indexToRemove
        )
        .then((res) => {
          if (!res.error) {
            this.getSubmittedData();
          } else {
          }
        });
      this.$emit("change", null);
    },
    submitJobRequest() {
      this.errmsg = "";
      let wastearray = [];
      this.wastearray = [];
      // checking waste type (should be the same)
      let comp = [];
      for (var i = 0; i < this.tableDatas.length; i++) {
        if (comp.indexOf(this.tableDatas[i].nickname) === -1) {
          comp.push(this.tableDatas[i].nickname);
        }
      }

      if (comp.length == 1) {
        let compulsoryitemflag = false;
        // check waste type to assign different obj
        let obj = {};

        if (
          this.tableDatas[0].nickname == "schedule_waste" ||
          this.tableDatas[0].nickname == "others"
        ) {
          this.tableDatas.forEach((data) => {
            // if (
            //   (data.wastetype === "4" && data.swcode === null) ||
            //   data.swcode === ""
            // ) {
            //   this.modals.warningsubmit = true;
            // }

            if (
              // data.wastetype === null ||
              data.wastetype != "" &&
              data.wasteComponents.length != 0 &&
              // data.wasteComponents === "" ||
              // data.wasteorigin === null ||
              data.wasteorigin != "" &&
              // data.packaging === null ||
              data.packaging != "" &&
              // data.estqty === null ||
              data.estqty != "" &&
              // data.estqtyy === null ||
              data.estqtyy != "" &&
              // data.measurement === null ||
              data.measurement != ""
            ) {
              this.wastearray.push({
                waste_type:
                  data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                waste_sub_type: data.wastetype === 1 ? data.swcode : null,
                waste_component: data.wasteComponents,
                waste_source: data.wasteorigin,
                packaging_type: data.packaging,
                packaging_quantity: parseInt(data.estqtyy),
                estimate_quantity: parseInt(data.estqty),
                estimate_quantity_unit: data.measurement,
                remarks: data.remarks,
                images: data.images,
              });
              compulsoryitemflag = true;
            } else {
              compulsoryitemflag = false;
              this.errmsg = "Please fill all the required data.";
            }
          });

          if (compulsoryitemflag == true) {
            obj = {
              reference_no: this.jobno,
              collection_date: this.collectiondate, // get from first step
              service_location_id: this.selects.location,
              service_location_collection_id:
                this.selects.collection == "" ? 0 : this.selects.collection,
              pic_id: this.selects.pic,
              waste: this.wastearray,
            };

            this.$http
              .post(":10001/api/v1/incoming/" + this.jobno, obj)
              .then((res) => {
                let response = res.message;

                if (!res.error) {
                  console.log("hewo ", response);
                  this.submitData();
                  this.modals.warningsubmit = false;
                } else if (res.error) {
                  this.modals.warningsubmit = false;

                  swal({
                    title: "Data Error!",
                    text: `${res.message}`,
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                }
              });
          }
        }

        if (this.tableDatas[0].nickname == "garbage") {
          this.tableDatas.forEach((data) => {
            if (
              // data.wastetype === null ||
              data.wastetype != "" &&
              // data.wasteComponents === null ||
              data.wasteComponents.length != 0 &&
              // data.wasteorigin === null ||
              data.wasteorigin != "" &&
              // data.packaging === null ||
              data.packaging != "" &&
              // data.estqty === null ||
              data.estqty != "" &&
              // data.estqtyy === null ||
              data.estqtyy != "" &&
              // data.measurement === null ||
              data.measurement != ""
            ) {
              wastearray.push({
                waste_type_id:
                  data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                waste_components: data.wasteComponents, //check
                waste_origin: data.wasteorigin,
                packaging_type_id: parseInt(data.packaging),
                packaging_quantity: parseInt(data.estqtyy),
                estimated_quantity: parseInt(data.estqty),
                estimated_quantity_unit: data.measurement,
                remark: data.remarks,
                // waste_sub_type: data.wastetype === 1 ? data.swcode : null,
              });
              compulsoryitemflag = true;
            } else {
              compulsoryitemflag = false;
              this.errmsg = "Please fill all the required data.";
            }
          });

          if (compulsoryitemflag == true) {
            obj = {
              reference_no: this.jobno,
              collection_date: this.collectiondate, // get from first step
              service_location_id: this.selects.location,
              service_location_collection_id:
                this.selects.collection == "" ? 0 : this.selects.collection,
              pic_id: this.selects.pic,
              wastes: wastearray,
            };

            console.log("onject", obj);

            this.$http
              .post(":10001/api/v1/incoming/garbage/" + this.jobno, obj)
              .then((res) => {
                if (!res.error) {
                  let response = res.message;
                  if (!res.error) {
                    this.submitData();
                    this.modals.warningsubmit = false;
                  } else if (res.error) {
                    this.modals.warningsubmit = false;

                    swal({
                      title: "Data Error!",
                      text: `${res.message}`,
                      type: "warning",
                      confirmButtonClass: "btn btn-success btn-fill",
                      confirmButtonText: "Okay",
                      buttonsStyling: false,
                    });
                  }
                }
              });
          }
        }

        if (this.tableDatas[0].nickname == "scrap") {
          console.log(" this is scrap !!!");
          this.tableDatas.forEach((data) => {
            console.log(data);
            if (
              // data.wastetype === null ||
              data.wastetype != "" &&
              // data.wasteComponents === null ||
              data.wasteComponents.length != 0 &&
              // data.wasteorigin === null ||
              data.wasteorigin != "" &&
              // data.packaging === null ||
              data.packaging != "" &&
              // data.estqty === null ||
              data.estqty != "" &&
              // data.estqtyy === null ||
              data.estqtyy != "" &&
              // data.measurement === null ||
              data.measurement != ""
            ) {
              wastearray.push({
                waste_type_id:
                  data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                waste_components: data.wasteComponents, //check
                waste_origin: data.wasteorigin,
                packaging_type_id: parseInt(data.packaging),
                packaging_quantity: parseInt(data.estqtyy),
                estimated_quantity: parseInt(data.estqty),
                estimated_quantity_unit: data.measurement,
                remark: data.remarks,
                images: data.images,
                // waste_sub_type: data.wastetype === 1 ? data.swcode : null,
              });
              compulsoryitemflag = true;
            } else {
              compulsoryitemflag = false;
              this.errmsg = "Please fill all the required data.";
            }
          });

          if (compulsoryitemflag == true) {
            console.log("waste array", this.wastearray);

            obj = {
              reference_no: this.jobno,
              collection_date: this.collectiondate, // get from first step
              service_location_id: this.selects.location,
              service_location_collection_id:
                this.selects.collection == "" ? 0 : this.selects.collection,
              pic_id: this.selects.pic,
              wastes: wastearray,
            };
            console.log("obj array", obj);

            this.$http
              .post(":10001/api/v1/incoming/scrap/" + this.jobno, obj)
              .then((res) => {
                if (!res.error) {
                  let response = res.message;
                  if (!res.error) {
                    console.log("data submit masuk", response);
                    this.submitData();
                    this.modals.warningsubmit = false;
                  } else if (res.error) {
                    console.log("data tak masuk");
                    this.modals.warningsubmit = false;

                    swal({
                      title: "Data Error!",
                      text: `${res.message}`,
                      type: "warning",
                      confirmButtonClass: "btn btn-success btn-fill",
                      confirmButtonText: "Okay",
                      buttonsStyling: false,
                    });
                  }
                }
              });
          }
        }

        if (this.tableDatas[0].nickname == "tyre") {
          console.log(" this is tyre !!!");
          this.tableDatas.forEach((data) => {
            console.log(data);
            if (
              data.wastetype != "" &&
              data.swcode != "" &&
              // data.wasteComponents === null ||
              // data.wasteComponents.length != 0  &&
              // data.wasteorigin === null ||
              data.wasteorigin != "" &&
              // data.packaging === null ||
              // data.packaging != "" &&
              // data.estqty === null ||
              data.estqty != ""
              // data.estqtyy === null ||
              // data.estqtyy != "" &&
              // data.measurement === null ||
              // data.measurement != ""
            ) {
              wastearray.push({
                waste_type_id: data.wastetype,
                // data.wastetype === 4 ? this.newwastetypeid : data.wastetype,
                // waste_components: data.wasteComponents, //check
                waste_origin: data.wasteorigin,
                // packaging_type_id: data.packaging,
                // packaging_quantity: parseInt(data.estqtyy),
                estimated_quantity: parseInt(data.estqty),
                estimated_quantity_unit: "Unit",
                remark: data.remarks,
                images: data.images,
                waste_sub_type_id: data.swcode,
              });
              compulsoryitemflag = true;
            } else {
              compulsoryitemflag = false;
              this.errmsg = "Please fill all the required data.";
            }

            console.log(data.wastetype);
          });

          if (compulsoryitemflag == true) {
            console.log("waste array", wastearray);

            obj = {
              reference_no: this.jobno,
              collection_date: this.collectiondate, // get from first step
              service_location_id: this.selects.location,
              service_location_collection_id:
                this.selects.collection == "" ? 0 : this.selects.collection,
              pic_id: this.selects.pic,
              wastes: wastearray,
            };
            console.log("obj array", obj);

            this.$http
              .post(":10001/api/v1/incoming/tyre/" + this.jobno, obj)
              .then((res) => {
                if (!res.error) {
                  let response = res.message;
                  if (!res.error) {
                    console.log("data submit masuk", response);
                    this.submitData();
                    this.modals.warningsubmit = false;
                  } else if (res.error) {
                    console.log("data tak masuk");
                    this.modals.warningsubmit = false;

                    swal({
                      title: "Data Error!",
                      text: `${res.message}`,
                      type: "warning",
                      confirmButtonClass: "btn btn-success btn-fill",
                      confirmButtonText: "Okay",
                      buttonsStyling: false,
                    });
                  }
                }
              });
          }
        }
      } else {
        this.warning = true;
        this.otherswarning = "Waste type must be the same for each row";
      }
    },
    addWasteComponent(index) {
      this.tableDatas[index].wasteComponents.push({ component_name: "" });
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getLocation() {
      this.selects.locations = [];
      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };

            this.selects.locations.push(obj);
          }

          // this.selects.location = this.selects.locations[0].value;
        }
      });
    },
    getPIC() {
      this.selects.pics = [];
      this.picdetail = [];

      this.$http.get(":10001/api/v1/self/pic").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].user_name,
              value: response[i].user_id,
              id: response[i].user_id,
              name: response[i].user_name,
              phoneno: response[i].user_phone_number,
              faxno: response[i].user_fax_number,
              email: response[i].user_email,
            };

            this.selects.pics.push(obj);

            // let obj2 = {
            //   id: response[i].user_id,
            //   name: response[i].user_name,
            //   phoneno: response[i].user_phone_number,
            //   faxno: response[i].user_fax_number,
            //   email: response[i].user_email,
            // };

            // this.picdetail.push(obj2);
          }

          this.selects.pic = this.selects.pics[0].value;
        }
      });
    },
    getWasteType() {
      this.selects.wastetypes = [];
      this.$http.get(":10001/api/v1/self/waste-type").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].waste_type_id,
              flag: response[i].nickname,
            };

            this.selects.wastetypes.push(obj);
          }

          // this.selects.wastetype = this.selects.wastetypes[0].value;
        }
      });
    },
    getSWCode(row, index) {
      this.imgmsg = "";
      console.log(row);
      this.selects.swcodes = [];

      let flag = "no";
      let count = 0;
      // for (var i = 0; i < this.tableDatas.length; i++) {
      for (var j = 0; j < this.selects.wastetypes.length; j++) {
        if (
          this.tableDatas[index].wastetype == this.selects.wastetypes[j].value
        ) {
          this.tableDatas[index].nickname = this.selects.wastetypes[j].flag;
          flag = "yes";
          count++;
        }
      }
      console.log(this.tableDatas[index].nickname);

      if (flag == "yes") {
        if (
          this.tableDatas[index].nickname == "schedule_waste" ||
          this.tableDatas[index].nickname == "tyre"
        ) {
          this.$http.get(":10001/api/v1/self/waste-type/" + row).then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.tableDatas[index].swcodes = [];
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  label: response[i].name,
                  value: response[i].waste_type_sub_id,
                };

                this.tableDatas[index].swcodes.push(obj);
                // this.selects.swcodes.push(obj);
              }

              console.log(this.tableDatas[index].swcodes);

              // this.tableDatas[index].swcode = this.selects.swcodes[0].value;
            }
          });
        }
      }

      if (
        this.tableDatas[index].nickname == "garbage" ||
        this.tableDatas[index].nickname == "scrap"
      ) {
        this.wastetype = "noshow";
      }
      if (
        this.tableDatas[index].nickname == "schedule_waste" ||
        this.tableDatas[index].nickname == "tyre" ||
        this.tableDatas[index].nickname == "others"
      ) {
        this.wastetype = "show";
      }

      if (
        this.tableDatas[index].nickname == "tyre" ||
        this.tableDatas[index].nickname == "scrap"
      ) {
        this.wastecomp = "show";
      }

      if (
        this.tableDatas[index].nickname != "tyre" &&
        this.tableDatas[index].nickname != "scrap"
      ) {
        this.wastecomp = "noshow";
      }
      console.log(this.wastetype);
    },
    getPackaging() {
      this.selects.packagings = [];
      this.$http.get(":10001/api/v1/reference/packaging").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].packaging_type_id,
            };

            this.selects.packagings.push(obj);
          }

          // this.selects.packaging = this.selects.packagings[0].value;
          this.selects.packaging = this.selects.packagings[0].value;
        }
      });
    },
    getDatas() {
      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
        }
      });
    },
    getType2(row) {
      row.packagingname = this.selects.packagings[row.packaging - 1].label;
    },
    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        // this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  /* height: 20px; */
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

/* Add this CSS to your stylesheet */
.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
  /* Ensure there is a vertical scrollbar */
}

/* Webkit browsers (Chrome, Safari) */
.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  /* Set the color of the scrollbar thumb */
  border-radius: 6px;
  /* Set the border radius of the scrollbar thumb */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Set the color of the scrollbar track */
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
</style>
